import React from 'react';
import createReactClass from 'create-react-class';

import { AppHeader, getIdFromParams } from '@/exceed';
import axios from '@/util/axios';
import { handleAxiosError } from 'core/notifications';
import i18n from 'i18next';
import { withContainer } from 'core/cache';

import addDeleteInitiativeModal from '../helpers/addDeleteInitiativeModal';
import { getInitiative, getTopicSelection } from '../helpers/getMockData';

const InsightsHeaderContainer = createReactClass({
  async handleDeleteButtonClick() {
    const { type } = await addDeleteInitiativeModal();

    if (type !== 'delete') return;

    try {
      await axios.delete(`/api/admin/initiatives/${getIdFromParams(this.props)}`);
    } catch (error) {
      return handleAxiosError(error);
    }

    this.props.history.replace('/initiatives');
  },

  getInitiativeName() {
    const { initiative, initiatives } = this.props;

    if (initiative.status === 'success') {
      return initiative.data.name;
    }

    const paramId = getIdFromParams(this.props);

    return initiatives.data?.find(({ id }) => id === paramId).name;
  },

  getDeleAction() {
    return [{
      id: 1,
      variant: 'link',
      size: 'xsmall',
      icon: 'delete',
      color: 'brand',
      text: i18n.t('delete'),
      onClick: this.handleDeleteButtonClick,
    }];
  },

  render() {
    const {
      hasDeleteButton,
      hasHomeLink,
      hasInitiativeTitle,
      initiative,
      title,
    } = this.props;

    if (!hasInitiativeTitle && !title) return null;

    return (
      <AppHeader
        hasHeaderActions={hasDeleteButton && initiative.status === 'success'}
        hasHomeLink={hasHomeLink}
        homeRoute="/initiatives"
        homeText={i18n.t('initiatives')}
        title={hasInitiativeTitle ? this.getInitiativeName() : title}
        appHeaderActions={this.getDeleAction()}
      />
    );
  },
});

export default withContainer(InsightsHeaderContainer, {
  cache: {
    initiatives: { isListener: true },
    initiative: {
      getDependencies: ({ props }) => {
        const isInitiative = props.hasInitiativeTitle || props.title;

        return [isInitiative && !Number.isNaN(getIdFromParams(props))];
      },
      getMockedResponse: ({ props }) => ({
        data: getInitiative(getIdFromParams(props)),
      }),
      getParams: ({ props }) => ({ id: getIdFromParams(props) }),
      initialData: {},
      isMocked: false,
      transform: ({ data }) => data.data,
      url: '/api/admin/initiatives/:id',
    },
    topicSelection: {
      getDependencies: ({ props }) => [props.initiative.status === 'success'],
      getMockedResponse: () => ({ data: getTopicSelection() }),
      getParams: ({ props }) => ({ id: props.initiative.data.id }),
      initialData: [],
      isMocked: false,
      transform: ({ data }) => data.data,
      url: '/api/admin/initiatives/:id/tagged_topics',
    },
  },
  hasRouter: true,
});
